function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

export var validateHEX = function validateHEX(hex) {
  var reg = /^#?[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/;
  return reg.test(hex);
};
export var validateRGB = function validateRGB(_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      r = _ref2[0],
      g = _ref2[1],
      b = _ref2[2];

  var reg = /^\d{1,3}$/;
  return reg.test(r) && reg.test(g) && reg.test(b) && parseInt(r, 10) <= 255 && parseInt(g, 10) <= 255 && parseInt(b, 10) <= 255;
};
export var validateA = function validateA(v) {
  var reg = /^\d{1,3}$/;
  return reg.test(v) && parseInt(v, 10) <= 100;
};
export var formatHEX = function formatHEX(hex) {
  return hex.charAt(0) === '#' ? hex : "#".concat(hex);
};
export var RGBToHEX = function RGBToHEX(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 3),
      r = _ref4[0],
      g = _ref4[1],
      b = _ref4[2];

  return ['#', r < 16 ? "0".concat(r.toString(16)) : r.toString(16), g < 16 ? "0".concat(g.toString(16)) : g.toString(16), b < 16 ? "0".concat(b.toString(16)) : b.toString(16)].join('').toUpperCase();
};
export var HEXToRGB = function HEXToRGB(hex) {
  var r;
  var g;
  var b;
  var innerHex = hex;

  if (hex.charAt(0) === '#') {
    innerHex = hex.slice(1);
  }

  if (innerHex.length === 6) {
    r = parseInt(innerHex.substring(0, 2), 16);
    g = parseInt(innerHex.substring(2, 4), 16);
    b = parseInt(innerHex.substring(4), 16);
  } else {
    r = parseInt(innerHex.charAt(0).repeat(2), 16);
    g = parseInt(innerHex.charAt(1).repeat(2), 16);
    b = parseInt(innerHex.charAt(2).repeat(2), 16);
  }

  return [r, g, b];
};